<div class="content-container" style="background-color: white;">

    <div class="phone-input-container">
        <img class="marketing-logo-image" src="/Images/logo-rackcoach-black.png" />

        <ng-container *ngIf="pageState == 'enter-number'">
            <p *ngIf="!user.TwoFactorEnabled">To keep your account secure, please verify using one of the following methods.</p>
            <p *ngIf="user.TwoFactorEnabled">Please verify using one of the following methods.</p>

            <mat-radio-group class="radio-group" [(ngModel)]="deliveryMethod">
                <mat-radio-button class="radio-button" *ngFor="let method of deliveryMethods" [value]="method">
                    {{method + (method != 'Email' && user.TwoFactorEnabled ? ' (' + user.TwoFactorPhoneNumber + ')' : '')}}
                </mat-radio-button>
            </mat-radio-group>

            <mat-form-field style="width: 75%" *ngIf="deliveryMethod != 'Email' && !phoneNumberInputReadonly">
                <input matInput placeholder="Phone" autocomplete="off" mask="(000) 000-0000" [(ngModel)]="phoneNumberInput">
            </mat-form-field>

            <button mat-flat-button color="primary" style="width: 100%; margin-top: 7px;" (click)="sendCode()" [disabled]="submitDisabled">Send Code</button>
            <a class="send-email" style="font-family: Helvetica; font-size: 14px; padding-left: 5px;" (click)="sendEmail()">Send me an email instead</a>
            <p style="color: red">{{errorText}}</p>
        </ng-container>

        <ng-container *ngIf="pageState == 'code-sent'">
            <p *ngIf="deliveryMethod != 'Email'">A code was sent to your phone number {{phoneNumberInput}}.</p>
            <p *ngIf="deliveryMethod == 'Email'">A code was sent to your Email.</p>
            <div style="width: 100%">
                <input class="rounded-input" placeholder="Enter Code" autocomplete="off" (keydown.enter)="verifyCode()" [maxlength]="6" mask="000000" [(ngModel)]="codeInput">
            </div>

            <button [disabled]="verifyCodeDisabled" mat-flat-button color="primary" style="width: 100%; margin-top: 7px;" (click)="verifyCode()">Verify</button>
            <span style="margin-top: 10px; display: flex; align-items: center; justify-content: center; height: 30px;">
                <input type="checkbox" *ngIf="user.TwoFactorEnabled" style="margin-right: 7px; transform: scale(1.2);" [(ngModel)]="remember2FA">
                <label>Remember this computer for 30 days</label>
            </span>
            <!-- <mat-checkbox *ngIf="user.TwoFactorEnabled" matInput style="margin-top: 7px" [(ngModel)]="remember2FA">Remember this computer for 30 days</mat-checkbox> -->
            <p style="color: red">{{errorText}}</p>

            <p *ngIf="newCodeSent" style="color: green">A new code was sent.</p>

            <div style="margin-top: 15px">
                <button style="margin-right: 5px;" mat-raised-button color="default" (click)="sendNewCode()">Send New Code</button>
                <button *ngIf="!phoneNumberHidden" mat-raised-button color="default" (click)="goBack()">Go Back</button>
            </div>
        </ng-container>

    </div>

</div>